<template>
  <el-dialog
    :title="appCategoryTitle"
    :visible="showAppCategory"
    width="670px"
    :close-on-click-modal="false"
    :before-close="handleClose"
  >
    <div class="plan-Category-dialog">
      <el-form ref="CategoryForm" :model="addCategoryForm" :rules="formRules" label-width="140px">
        <el-form-item label="类目名称：" prop="categoryName">
          <el-input size="medium" v-model.trim="addCategoryForm.categoryName" maxlength="20" show-word-limit></el-input>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="cancelCategoryForm">取 消</el-button>
      <el-button size="small" type="primary" @click="saveCategoryForm">保 存</el-button>
    </span>
  </el-dialog>
</template>
<script>
import {categoryDetail,addCategory,updateCategory} from "@/api/appOperateCourse"
import { DEEP_CLONE } from '@/utils/constants'
import wangeditorNew from '@/components/wangeditorNew/index.vue'
export default {
  props: {
    appCategoryTitle: {
      type: String
    },
    showAppCategory: {
      type: Boolean
    },
    selectCategoryRow:{
      type: Object,
      default: () => {}
    }
  },
  components: {
    wangeditorNew
  },
  data() {
    return {
      addCategoryForm: {
        categoryName:''
      },
      formRules: {
        'categoryName':[{ required: true, message: '此项为必填项', trigger: ['change', 'blur'] }],
      }
    }
  },
  async created() {
    if (JSON.stringify(this.selectCategoryRow) !== '{}') {
      this.addCategoryForm = DEEP_CLONE(this.selectCategoryRow)
    }
  },
  mounted() {

  },
  methods: {
    handleShareRemove() {
      this.typeFormData.sharePhoto = ''
    },
    // async getCategoryDetail() {
    //   let res = await categoryDetail({
    //     id: row.id
    //   })
    //   if (res.code === 0) {

    //   }
    // },
    async saveCategoryForm() {
      this.$refs.CategoryForm.validate(async(val) => {
        if (val) {
          if (this.selectCategoryRow.id) {
            let res = await updateCategory({
              id: this.selectCategoryRow.id,
              categoryName: this.addCategoryForm.categoryName
            })
            if (res.code === 0) {
              this.$message.success('保存成功')
              this.$emit('update:showAppCategory', false)
              this.$emit('getPageCategory')
            }
          } else {
            let res = await addCategory({
              categoryName: this.addCategoryForm.categoryName
            })
            if (res.code === 0) {
              this.$message.success('编辑成功')
              this.$emit('update:showAppCategory', false)
              this.$emit('getPageCategory')
            }
          }
        } else {
          return false
        }
      })
    },
    cancelCategoryForm() {
      this.$emit('update:showAppCategory', false)
    },
    handleClose() {
      this.$emit('update:showAppCategory', false)
    },
  },
};
</script>
<style lang="less" scoped>
/deep/.el-dialog__footer {
  text-align: center;
}
.plan-Category-dialog {
  /deep/.el-input-group__append .el-select {
    width:88px;
  }
  /deep/.el-input-group__append .el-select .el-input, .el-input-group__append .el-select .el-input--suffix {
    width: 88px;
  }
}
</style>
